import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { store } from './store';
import IdeasPage from './pages/IdeasPage';
import LoginPage from './pages/LoginPage';
import getTheme from './theme/theme';

const App: React.FC = () => {
    const [themeMode, setThemeMode] = useState<'light' | 'dark'>('dark');

    return (
        <Provider store={store}>
            <ThemeProvider theme={getTheme(themeMode)}>
                <CssBaseline />
                <Router>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/ideas" element={<IdeasPage />} />
                        <Route path="/" element={<Navigate to="/ideas" replace />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </Provider>
    );
};

export default App;
